import React from "react";
import { ClearedStyleRouterLink } from "@modules/Components";
import styled from "@emotion/styled";
import { defaultAction } from "@actions/defaultAction";
import { CHANGE_BUY_SEARCH_TEXT, SET_CATEGORY } from "@constants/actionTypes";
import { useDispatch } from "react-redux";

const Link = styled(ClearedStyleRouterLink)`
  font-size: 14px;
  font-weight: 500;
  line-height: 2.36;
  color: #777984;
  cursor: pointer;
  @media (max-width: 950px) {
    font-size: 13px;
  }
  @media (max-width: 767px) {
    line-height: 2;
    width: fit-content;
  }
`;

const InnerContainer = styled.span`
  display: block;
  position: relative;
  color: ${props => props.color};
  &:hover {
    color: ${props => props.hoverColor};
  }

  @media (max-width: 767px) {
    display: inline;
  }

  @media (max-height: 790px) {
    line-height: 1.9;
  }
`;

const PillContainer = styled.span`
  display: flex;
  align-items: center;
  height: 22px;
`;

const Pill = styled.span`
  box-shadow: 0 9px 18px 0 rgba(253, 165, 54, 0.3);
  background-color: #ff9c1b;
  height: 22px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 47px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: bold;
  text-align: center;
  margin-left: 13px;
`;

const Category = ({
  url,
  categoryId,
  categoryName,
  currentSelectedCategoryName,
  categoryUrl
}) => {
  const dispatch = useDispatch();

  return (
    <Link to={`/buy-gift-cards/${url}/`}>
      <InnerContainer
        key={categoryId}
        onClick={() => {
          dispatch(defaultAction(CHANGE_BUY_SEARCH_TEXT, ""));
          dispatch(defaultAction(SET_CATEGORY, categoryUrl));
        }}
        hoverColor={
          currentSelectedCategoryName === categoryName ? "#ff9c1b" : "#1f2021"
        }
        color={
          currentSelectedCategoryName === categoryName ? "#ff9c1b" : "#777984"
        }
      >
        {categoryUrl.toLowerCase() === "discounted-not-to-be-missed-cards" ? (
          <PillContainer>
            {categoryName}
            <Pill>New</Pill>
          </PillContainer>
        ) : (
          <>{categoryName}</>
        )}
      </InnerContainer>
    </Link>
  );
};

export default Category;
